import { omit } from 'lodash-es'
import { create, type StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import {
  type CommandMenuState,
  createCommandMenuStore,
} from '#src/stores/commandMenu.ts'
import {
  createDevToolsStore,
  type DevToolsState,
} from '#src/stores/devtools.ts'
import {
  createFeedbackDialogStore,
  type FeedbackDialogState,
} from '#src/stores/feedbackDialog.ts'
import { createPermsStore, type PermsState } from '#src/stores/perms.ts'

export interface OrderDisplayState {
  isOrderDisplayTwoColumn: boolean
  toggleOrderDisplayLayout: () => void
  showSuggestedOrderDocuments: boolean
  toggleShowSuggestedOrderDocuments: () => void
}

export const createOrderDisplayStore: StateCreator<OrderDisplayState> = (
  set
) => ({
  isOrderDisplayTwoColumn: false,
  toggleOrderDisplayLayout: () =>
    set((state: OrderDisplayState) => ({
      isOrderDisplayTwoColumn: !state.isOrderDisplayTwoColumn,
    })),
  showSuggestedOrderDocuments: true,
  toggleShowSuggestedOrderDocuments: () =>
    set((state: OrderDisplayState) => ({
      showSuggestedOrderDocuments: !state.showSuggestedOrderDocuments,
    })),
})

export const usePortalStore = create<
  DevToolsState &
    CommandMenuState &
    PermsState &
    OrderDisplayState &
    FeedbackDialogState
>()(
  devtools(
    persist(
      (...a) => ({
        ...createDevToolsStore(...a),
        ...createCommandMenuStore(...a),
        ...createPermsStore(...a),
        ...createOrderDisplayStore(...a),
        ...createFeedbackDialogStore(...a),
      }),
      {
        name: 'seen-prefs',
        partialize: (state) =>
          omit(
            state,
            'showLinkOverlay',
            'showDemoPatientsOnly',
            'showAdminActions',
            'showReactQueryDevtools',
            'feedbackDialogOpen'
          ),
      }
    ),
    {
      enabled: false,
    }
  )
)
